// Empty stub — replaces next/dist/build/polyfills/polyfill-module in the
// modern client bundle. Real polyfills load only when needed from
// /js/legacy-polyfills.js (see app/layout.tsx).
